import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import * as device from '../../app/redux/DevicesRedux'
import webSocketReducer from '../../app/redux/WebSocketSlice'
import responseModalReducer from '../../app/redux/ResponseModalSlice'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  device: device.reducer,
  webSocket: webSocketReducer,
  responseModal: responseModalReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga()])
}
